import { Flex, Text } from "@gravity-ui/uikit";
import { Link } from "src/components";
import { T } from "src/i18n";
import { RoutesPaths } from "src/routes/RoutesPaths";
import css from "src/widgets/Footer/Footer.module.scss";

export const LegalBlock = () => {
  return (
    <Flex direction={"column"} wrap={"wrap"} gap={4} className={css.legalBlock}>
      <Flex
        direction="column"
        justifyContent="start"
        gap={2}
        maxWidth={"280px"}
        minWidth={"200px"}
      >
        <Text>
          <T
            keyName={"footer.legal_block.fio"}
            defaultValue={"ИП Шестопавлова Анна Николаевна"}
          />
        </Text>
        <Text>
          <T
            keyName={"footer.legal_block.inn"}
            defaultValue={"ИНН: 143311835743"}
          />
        </Text>
        <Text>
          <T
            keyName={"footer.legal_block.ogrnip"}
            defaultValue={"ОГРНИП: 324140000055789"}
          />
        </Text>
        <Text>
          <T
            keyName={"footer.legal_block.patent"}
            defaultValue={"Применяет патентную систему налогообложения (ПСН)"}
          />
        </Text>
        <Text>
          <T
            keyName={"footer.legal_block.address"}
            defaultValue={
              "Юридический адрес: Республика Саха (Якутия), Мирнинский улус, г. Удачный, мкр. Новый город, д. 10, кв. 13"
            }
          />
        </Text>

        <Text>
          <T
            keyName={"footer.legal_block.payment"}
            defaultValue={
              "Оплата производится через интернет-эквайринг. Кассовый чек формируется в соответствии с 54-ФЗ и направляется на указанные вами email/телефон."
            }
          />
        </Text>
      </Flex>
      <Flex direction="column" justifyContent="start" gap={2}>
        <Link className={css.footerLink} to={RoutesPaths.PRIVACY}>
          <T
            keyName={"footer.links.privacy_policy"}
            defaultValue={"Политика конфиденциальности"}
          />
        </Link>

        <Link className={css.footerLink} to={RoutesPaths.OFFER}>
          <T keyName={"footer.links.offer"} defaultValue={"Публичная оферта"} />
        </Link>
      </Flex>
    </Flex>
  );
};
